import React, { useState, useEffect } from 'react'
import {
  Container,
  Typography,
  Box,
  Chip
} from '@mui/material'
import Catalog from './components/Catalog'
import PlayerView from './components/PlayerView'
import { catalog } from './data/catalog'
import { Sequence } from './types/catalog'

const App: React.FC = () => {
  const [selectedSequence, setSelectedSequence] = useState<Sequence | null>(null)
  const [xrSupport, setXrSupport] = useState<{
    ar: boolean | null
    vr: boolean | null
  }>({ ar: null, vr: null })

  useEffect(() => {
    const checkXRSupport = async () => {
      if ('xr' in navigator && navigator.xr) {
        try {
          const arSupported = await navigator.xr.isSessionSupported('immersive-ar')
          const vrSupported = await navigator.xr.isSessionSupported('immersive-vr')
          setXrSupport({ ar: arSupported, vr: vrSupported })
        } catch (error) {
          console.error('Error checking XR support:', error)
          setXrSupport({ ar: false, vr: false })
        }
      } else {
        setXrSupport({ ar: false, vr: false })
      }
    }

    checkXRSupport()
  }, [])

  const handleSequenceSelect = (sequence: Sequence) => {
    setSelectedSequence(sequence)
  }

  const handleClosePlayer = () => {
    setSelectedSequence(null)
  }

  return (
    <>
      {selectedSequence === null ? (
        <Container maxWidth="md" sx={{ py: 4 }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
                        <Box
              component="img"
              src="/favicon/Soapbox x snap logo.svg"
              alt="Snap Spectacles"
              sx={{
                width: '4em',
                height: '2em',
                display: 'inline-block',
                verticalAlign: 'middle',
              }}
            />
            Soapbox on Spectacles.
          </Typography>

          <Typography variant="h6" component="h4" gutterBottom>
          </Typography>

          <Box sx={{ mb: 4, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            <Typography variant="body2" sx={{ mr: 1 }}>
            </Typography>
            {/* {xrSupport.ar === null ? (
              <Chip label="Detecting..." size="small" />
            ) : (
              <Chip
                label={`AR: ${xrSupport.ar ? 'Supported' : 'Not Supported'}`}
                color={xrSupport.ar ? 'success' : 'default'}
                size="small"
              />
            )} */}
            {xrSupport.vr === null ? (
              <Chip label="Detecting..." size="small" />
            ) : (
              <Chip
                label={`VR ${xrSupport.vr ? 'supported on this device' : 'not Supported on this device'}`}
                color={xrSupport.vr ? 'success' : 'default'}
                size="small"
              />
            )}
          </Box>

          <Catalog
            playlists={catalog}
            onSequenceSelect={handleSequenceSelect}
            selectedSequence={selectedSequence}
          />
        </Container>
      ) : (
        <PlayerView sequence={selectedSequence} onClose={handleClosePlayer} />
      )}
    </>
  )
}

export default App